<template>
  <div class="col items-center">
    <div
        class="row items-center"
        v-for="(manager, id) in managers"
    >
      <project-user-input
          :manager="manager"
          @blurred="attachUser"
          @userChanged="attachUser"
      />

      <q-btn
          v-if="manager.id"
          @click="this.window.open(`/users/${manager.id}`, '_blank')"
          icon="call_made"
          flat
          round
      >
        <q-tooltip>
          Открыть страницу клиента
        </q-tooltip>
      </q-btn>

      <project-user-letter-toggler
          :user="manager"
      />

      <q-btn
          @click="detachManager(id, manager)"
          icon="delete"
          color="tertiary"
          class="hover-negative"
          flat
          round
      >
        <q-tooltip
        >
          Удалить
        </q-tooltip>
      </q-btn>
    </div>

    <q-btn
        @click="addManager"
    >
      Добавить
    </q-btn>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import {
  QField,
  QInput,
  QToggle,
  QBtn,
  QTooltip,
  QPopover,
  QList,
  QItem,
  QInfiniteScroll,
  QSpinnerDots,
} from 'quasar';

import ProjectUserInput from "./ProjectUserInput";
import projectUser from "../../mixins/projectUser/projectUser";
import ProjectUserLetterToggler from "./ProjectUserLetterToggler";

export default {
  name: "ProjectUsersList",

  components: {
    ProjectUserLetterToggler,
    ProjectUserInput,
    QField,
    QInput,
    QToggle,
    QBtn,
    QTooltip,
    QPopover,
    QList,
    QItem,
    QInfiniteScroll,
    QSpinnerDots,
  },

  mixins: [
    projectUser,
  ],

  methods: {
    addManager() {
      const user = {
        email: '',
        users: {
          is_owner: false,
          receive_letters: true,
        }
      }

      this.$store.commit('project/setManager', user)
    },

    detachManager(id, manager) {
      if (!manager.hasOwnProperty('id')) {
        const managers = this.managers.filter((_, index) => index !== id)

        this.$store.commit('project/setManagers', managers)

        return
      }

      this.$http.put(`api/v1.0/projects/${this.$route.params.id}/detach_user/${manager.id}`)
          .then((response) => {
            this.$q.notify({
              message: `Сохранено`,
              type: 'info',
              position: 'bottom'
            });

            this.$store.commit('project/setUsers', response.data)
          })
          .catch((error) => {
            _.forIn(error.response.data.errors, (value, key) => {
              this.$q.notify(value[0]);
            })
          });
    },
  },

  computed: {
    ...mapState({
      project: state => state.project.data,
      managers: state => _.cloneDeep(state.project.managers),
    }),
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectUsersList/ProjectUsersList.vue